/* RAYZ product page: option pills -> variant, price and availability, quantity stepper,
   gallery counter (phones), sticky add-to-bag bar. Adding to the bag itself is Dawn's
   product-form.js, which hands the response to the RAYZ <cart-drawer>. */
(function () {
  const money = (cents) => 'Rs. ' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  const plain = (cents) => (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });

  function init(root) {
    if (root.dataset.rzReady) return;
    root.dataset.rzReady = '1';
    const ref = (n) => root.querySelector(`[data-ref="${n}"]`);
    const refs = (n) => [...root.querySelectorAll(`[data-ref="${n}"]`)];
    const add = ref('add'), barAdd = ref('barAdd'), idInput = ref('id');
    const labels = { add: root.dataset.addLabel, sold: root.dataset.soldLabel, none: root.dataset.unavailableLabel };

    function setButton(btn, state) {
      if (!btn) return;
      btn.disabled = state !== 'add';
      btn.querySelector('span').textContent = labels[state];
    }

    /* options -> variant */
    const vjson = ref('variants');
    const variants = vjson ? JSON.parse(vjson.textContent) : [];
    const opts = ref('options');
    if (opts && variants.length) {
      opts.addEventListener('change', () => {
        const chosen = [...opts.querySelectorAll('fieldset')].map((f) => (f.querySelector('input:checked') || {}).value);
        opts.querySelectorAll('fieldset').forEach((f, i) => { const o = f.querySelector('[data-ref="optVal"]'); if (o) o.textContent = chosen[i] || ''; });
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        if (!v) { setButton(add, 'none'); setButton(barAdd, 'none'); return; }
        idInput.value = v.id;
        refs('price').concat(refs('barPrice')).forEach((el) => { el.textContent = money(v.price); });
        document.querySelectorAll('[data-rz-fp]').forEach((fp) => { const pct = +fp.dataset.pct || 50; const b = fp.querySelector('[data-rz-fp-price]'); if (b) b.textContent = money(v.price - Math.floor((v.price * pct) / 100)); });
        const cmp = ref('cmp'), off = ref('off');
        const hasCmp = v.compare_at_price && v.compare_at_price > v.price;
        if (cmp) { cmp.hidden = !hasCmp; cmp.textContent = hasCmp ? plain(v.compare_at_price) : ''; }
        if (off) { off.hidden = !hasCmp; off.textContent = hasCmp ? Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '% off' : ''; }
        setButton(add, v.available ? 'add' : 'sold'); setButton(barAdd, v.available ? 'add' : 'sold');
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        if (v.featured_media) {
          const fig = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
          const gal = ref('gallery');
          if (fig && gal && gal.scrollWidth > gal.clientWidth) gal.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    /* quantity stepper */
    const qty = ref('qty');
    if (qty) qty.addEventListener('click', (e) => {
      const b = e.target.closest('[data-step]'); if (!b) return;
      const input = qty.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +b.dataset.step);
    });

    /* gallery counter on the phone carousel */
    const gal = ref('gallery'), idx = ref('idx');
    if (gal && idx) {
      const figs = [...gal.children];
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting && e.intersectionRatio > 0.6) idx.textContent = String(figs.indexOf(e.target) + 1).padStart(2, '0');
      }), { root: gal, threshold: [0.6] });
      figs.forEach((f) => io.observe(f));
    }

    /* sticky bar: shows once the main add button has scrolled away (on phones, also before it is
       reached), hides over the footer */
    const bar = ref('bar');
    if (bar && add) {
      let past = false, nearEnd = false;
      const sync = () => {
        const on = past && !nearEnd;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (barAdd) barAdd.tabIndex = on ? 0 : -1;
      };
      const phone = matchMedia('(max-width: 989px)');
      new IntersectionObserver(([e]) => { past = !e.isIntersecting && (phone.matches || e.boundingClientRect.top < 0); sync(); }).observe(add);
      const foot = document.querySelector('.rz-foot');
      if (foot) new IntersectionObserver(([e]) => { nearEnd = e.isIntersecting; sync(); }).observe(foot);
      // the gallery images push the button down after the first layout, so look again once they have loaded
      const recheck = () => {
        const r = add.getBoundingClientRect();
        past = r.bottom < 0 || (phone.matches && r.top > innerHeight);
        if (foot) { const f = foot.getBoundingClientRect(); nearEnd = f.top < innerHeight && f.bottom > 0; }
        sync();
      };
      if (document.readyState === 'complete') recheck(); else addEventListener('load', recheck, { once: true });
      setTimeout(recheck, 1500);
    }
  }

  const run = (r) => r.querySelectorAll('[data-rz-pdp]').forEach(init);
  run(document);
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
